export default __webpack_public_path__ + "static/media/icon-ready-to-use.04d8be59.svg";